import { Navigate, useLocation } from 'react-router-dom';
import { hasUsableSession } from '../../utils/authHelpers';

/**
 * 로그인된 사용자만 접근 가능한 라우트 보호 컴포넌트
 * (서비스 타입 권한과 무관하게 단순히 accessToken 존재 여부로 판단)
 *
 * 미로그인 시 /login으로 리다이렉트하면서 원래 가려던 경로를 state.from에 저장
 */
function AuthRequiredRoute({ children }) {
  const location = useLocation();
  // 토큰만 있고 사용자 정보가 없으면 못 쓰는 세션이다 — 로그인 화면으로 보낸다
  if (!hasUsableSession()) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  return children;
}

export default AuthRequiredRoute;
